import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useRef, useState } from 'react';
import { useTheme } from 'styled-components';
import { ColorBullet } from '../../components/ColorBullet';
import { useClickOutside } from '../../hooks';
import { Dropdown, Icon, Text } from '../../ui';
import { StyledColorIconPrefix, StyledContainer, StyledDropdownOptionWrapper, StyledDropdownOptionsContainer, StyledIconWrapper, StyledLabelContainer, } from './ColorSelect.style';
export function ColorSelect({ customColorLabel, limit = 8, onChange, options, transparentLabel, defaultValue, }) {
    const [customColor, setCustomColor] = useState([]);
    const [selected, setSelected] = useState(options.find((option) => option.value === defaultValue) || options[0]);
    const [color, setColor] = useState('');
    const [isOpened, setIsOpened] = useState(false);
    const [dimensions, setDimensions] = useState({ top: 0, left: 0, width: 0 });
    const labelRef = useRef(null);
    const theme = useTheme();
    const handleClickOutside = () => {
        if (color) {
            onPickerChange(color);
            onChangeHandler(color);
        }
        setIsOpened(false);
        setColor('');
    };
    const containerRef = useClickOutside(handleClickOutside);
    const toggleVisibility = useCallback((visible) => {
        setIsOpened((previous) => {
            const isVisible = visible !== null && visible !== void 0 ? visible : !previous;
            if (isVisible && labelRef.current) {
                const boundingClientRect = labelRef.current.getBoundingClientRect();
                setDimensions({
                    left: boundingClientRect.left,
                    top: boundingClientRect.top +
                        boundingClientRect.height +
                        theme.Spacing.Size.XXSmall,
                    width: boundingClientRect.width,
                });
            }
            return isVisible;
        });
    }, []);
    const onPickerChange = useCallback((value) => {
        setColor(value);
        if (customColor.find((color) => color.value === value)) {
            return;
        }
        setCustomColor((prev) => {
            const updatedCustomColor = prev.concat({ label: value, value });
            return updatedCustomColor.slice(-limit);
        });
    }, [setColor, customColor, setCustomColor, limit]);
    const onChangeHandler = useCallback((selectedValue) => {
        toggleVisibility(false);
        if (selectedValue !== selected.value || selectedValue === 'transparent') {
            const selectedColor = options.concat(customColor).find((option) => option.value === selectedValue);
            setSelected(selectedColor !== null && selectedColor !== void 0 ? selectedColor : {
                label: selectedValue,
                value: selectedValue,
            });
            onChange === null || onChange === void 0 ? void 0 : onChange(selectedValue);
        }
    }, [toggleVisibility, selected.value, options, customColor, onChange]);
    return (_jsxs(StyledContainer, { ref: containerRef, children: [_jsxs(StyledLabelContainer, { onClick: () => toggleVisibility(), ref: labelRef, isOpened: isOpened, children: [_jsx(StyledColorIconPrefix, { children: selected.value === 'transparent' ? (_jsx(Icon, { name: "library---20", color: theme.Color.Neutrals.Dark, size: "XSmall" })) : (_jsx(ColorBullet, { color: selected.value, variant: "rounded", size: "Small", readOnly: true })) }), _jsx(Text, { size: 'Body', children: selected.label }), _jsx(StyledIconWrapper, { children: _jsx(Icon, { name: "chevron---20", angle: isOpened ? 180 : 0, color: theme.Color.Neutrals.Dark }) })] }), _jsx(Dropdown, { dimensions: dimensions, opened: isOpened, onSelect: onChangeHandler, children: _jsx(StyledDropdownOptionsContainer, { children: options.concat(customColor).map((option, index) => {
                        return (_jsx(StyledDropdownOptionWrapper, { onClick: (event) => {
                                option.value === '' && event.stopPropagation();
                            }, children: _jsx(ColorBullet, { color: option.value, isPicker: option.label === 'picker', isSelected: option.value === selected.value, onChange: (value) => {
                                    option.label === 'picker'
                                        ? setColor(value)
                                        : onChangeHandler(option.value);
                                }, readOnly: option.label !== 'picker', size: "Large", title: option.label === 'picker'
                                    ? customColorLabel
                                    : option.value === 'transparent'
                                        ? transparentLabel
                                        : undefined, variant: "rounded" }) }, `dropdown-option-${option.label}-${index}`));
                    }) }) })] }));
}
//# sourceMappingURL=ColorSelect.js.map